package it.neckar.lizergy.model.configuration.components

import it.neckar.commons.tags.Tags
import it.neckar.commons.tags.toTags
import it.neckar.lizergy.model.configuration.quote.builder.LizergyCalculationCategories
import it.neckar.lizergy.model.financial.currency.PriceWithProfit
import it.neckar.lizergy.model.financial.currency.ValueAddedTax
import it.neckar.open.formatting.format
import it.neckar.uuid.HasUuid
import it.neckar.uuid.NativeUuid
import it.neckar.uuid.randomUuid4
import kotlinx.serialization.Serializable
import kotlin.uuid.Uuid

@Serializable
data class ConfigurationItem(

  val id: ConfigurationItemId,

  val headline: String,

  val details: String,
  /**
   * The price for *one* item.
   * Is multiplied with [amount]
   */
  val priceForOneElement: PriceWithProfit,

  /**
   * The amount
   */
  val amount: Double = 1.0,

  /**
   * The tags this item is relevant for.
   *
   * Can be used to calculate sums / discounts etc.
   */
  val relevance: Tags = Tags.empty,

  val valueAddedTax: ValueAddedTax = ValueAddedTax.nineteenPercent,

  ) : HasUuid {

  override val uuid: Uuid
    get() = id.uuid

  val sum: PriceWithProfit
    get() = priceForOneElement.timesAndRound(amount)

  val isEmpty: Boolean
    get() = headline.isEmpty() && details.isEmpty() && priceForOneElement == PriceWithProfit.Zero

  fun duplicate(mapOfOldToNewUuids: MutableMap<Uuid, Uuid>): ConfigurationItem {
    val newId = ConfigurationItemId.random()
    mapOfOldToNewUuids[id.uuid] = newId.uuid
    return copy(id = newId)
  }

  fun format(): String {
    return "$headline: $details, Menge: ${amount.format(0)}"
  }

  /**
   * An id for a [ConfigurationItem]
   */
  @Serializable
  data class ConfigurationItemId(override val uuid: NativeUuid) : HasUuid {

    override fun toString(): String {
      return uuid.toString()
    }

    companion object {
      fun random(): ConfigurationItemId {
        return ConfigurationItemId(randomUuid4())
      }
    }
  }

  companion object {
    fun getRisikoZuschlag(id: ConfigurationItemId = ConfigurationItemId.random()): ConfigurationItem = ConfigurationItem(
      id = id,
      headline = "Risikozuschlag",
      details = "",
      priceForOneElement = PriceWithProfit.Zero,
      amount = 1.0,
      relevance = LizergyCalculationCategories.EconomicsCalculation.toTags(),
      valueAddedTax = ValueAddedTax.zero,
    )

    fun getEmpty(id: ConfigurationItemId = ConfigurationItemId.random(), valueAddedTax: ValueAddedTax): ConfigurationItem {
      return ConfigurationItem(
        id = id,
        headline = "",
        details = "",
        priceForOneElement = PriceWithProfit.Zero,
        valueAddedTax = valueAddedTax,
      )
    }
  }

}
